'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import { InternalProvider, useComponentDeprecation } from '../../util';
import { SelectionCardStrip } from '../../core-components/SelectionCardStrip';
import { ToggleCore } from '../../core-components';
/**
 * @deprecated
 */
export const RadioSelectionCard = /*#__PURE__*/React.forwardRef(({
  id,
  className = '',
  showCircle = true,
  children,
  ...props
}, fref) => {
  useComponentDeprecation({
    name: 'RadioSelectionCard',
    alternative: 'ActionCard',
    version: '5'
  });
  const [isFocused, setIsFocused] = useState(false);
  if (typeof children !== 'string') {
    children = /*#__PURE__*/React.createElement(SelectionCardStrip.InternalWrapper, {
      disableSvgColorOverride: props.disableSvgColorOverride,
      isDisabled: props.disabled
    }, children);
  }
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(SelectionCardStrip.Wrapper, {
    "data-aui": "radio-selection-card",
    id: id,
    className: className,
    focused: isFocused,
    disabled: props.disabled,
    checked: props.checked,
    disableSvgColorOverride: props.disableSvgColorOverride
  }, /*#__PURE__*/React.createElement(ToggleCore, _extends({
    id: id && `${id}-toggle`,
    toggleType: "radio",
    onFocusChange: setIsFocused,
    ref: fref,
    isToggleShowing: showCircle
  }, props), children)));
});